import React, { createContext, useContext } from 'react';

const translations = {
  es: {
    // Arcade lite
    insertCoin: 'AI Soft Skills Simulation | Negotiation Arena',
    pressStart: 'PULSA START',
    chooseSituation: 'Elige tu contraparte',
    chooseSituationDesc: 'Dos situaciones de negociación reales, elige tu contraparte e inicia la sesión.',
    selectSituationToStart: 'Selecciona una situación para empezar',
    readyToStart: 'Listo para iniciar',
    gameOver: 'FIN DE PARTIDA',
    stageClear: 'NIVEL COMPLETADO',
    temperature: 'TEMP',
    // Header
    simulationAI: 'SimulationAI',
    idbAse: 'Habilidades de campo',
    live: 'En vivo',
    restart: 'Reiniciar',
    contentManager: 'Gestor de contenido',

    // Loading
    loadingConfig: 'Cargando configuración...',
    restoringConversation: 'Restaurando conversación...',

    // Introduction
    safeguards: 'Salvaguardias ambientales y sociales',
    introTitle1: 'Entrena tus habilidades durante',
    introTitle2: 'una visita de campo',
    introSubtitle: 'Este simulador entrena tus habilidades blandas — comunicación, liderazgo, negociación y más — en conversaciones reales durante una visita de campo. No se evalúa tu conocimiento técnico, sino cómo te comunicas y gestionas la interacción.',
    startPractice: 'Comenzar práctica',
    introCtaBarHint: 'Para avanzar, pulsa el botón verde. Luego elegirás escenario, nivel y habilidad.',
    sessionTime: 'Aproximadamente 10–15 minutos por sesión · Voz y texto',
    introStep1Title: 'Escenario',
    introStep1Desc: 'Elige el sector y nivel del proyecto a supervisar.',
    introStep2Title: 'Nivel',
    introStep2Desc: 'Define la complejidad del desafío.',
    introStep3Title: 'Habilidad',
    introStep3Desc: 'Selecciona qué soft skill quieres practicar.',
    introStep4Title: 'Simulación',
    introStep4Desc: 'Conversa por voz o texto con tu interlocutor.',

    // Scenario selector
    stepXofY: 'Paso {x} de {y}',
    back: 'Volver',
    continue: 'Continuar',
    selectScenario: 'Selecciona un escenario para continuar',
    selectLevel: 'Selecciona un nivel de dificultad',
    chooseScenario: 'Elige un escenario',
    chooseScenarioDesc: 'Selecciona el tipo de proyecto donde realizarás tu visita de campo.',
    difficultyLevel: 'Nivel de dificultad',
    basic: 'Básico',
    intermediate: 'Intermedio',
    advanced: 'Avanzado',
    basicDesc: 'Conversación guiada con un representante cooperativo. Las preguntas clave aparecen como sugerencias.',
    intermediateDesc: 'El representante muestra resistencia parcial y respuestas evasivas. Sin sugerencias automáticas.',
    advancedDesc: 'Múltiples interlocutores, información contradictoria y presión de tiempo. Decisiones con consecuencias.',
    challenges: '{n} desafíos',

    // Skill selector
    chooseSkill: 'Elige tu habilidad',
    chooseSkillDesc: 'Selecciona la competencia que quieres practicar en esta simulación.',
    selectedSkill: 'Habilidad seleccionada',
    startSimulation: 'Iniciar simulación',
    selectSkillToContinue: 'Selecciona una habilidad para continuar',
    definition: 'Definición',
    appliedToSARAS: 'Aplicado al SARAS',
    expectedExamples: 'Ejemplos esperados',

    // Simulation view
    handsFree: 'Manos libres',
    handsFreeOn: 'Manos libres ON',
    handsFreeOff: 'Manos libres OFF',
    recording: 'Grabando',
    sessionCompleted: 'Sesión completada',
    yourScore: 'Tu puntaje',
    pts: 'pts',
    showMore: 'Ver más',
    showLess: 'Ocultar detalles',
    evaluatedOn: 'Evaluado en',
    yourScenario: 'Tu escenario',
    visitContext: 'Contexto de la visita',
    howToStart: 'Tu misión',
    howToStartDesc: 'Lleva la conversación hacia el acuerdo que necesitas. Defiende tu posición, escucha la del otro y negocia con argumentos. Pulsa INICIAR para comenzar.',
    understood: 'Entendido',
    start: 'Iniciar',
    loadingAvatar: 'Cargando avatar...',
    speaking: 'Hablando',
    listening: 'Escuchando',
    thinking: 'Pensando',
    thinkingDots: 'Pensando...',
    preparingAudio: 'Preparando audio...',
    listeningDots: 'Escuchando...',
    representativeSpeaking: 'El representante está hablando...',
    speakWhenReady: 'Habla cuando estés listo',
    userLabel: 'USUARIO',
    subtitlesOn: 'Subtítulos activos',
    subtitlesOff: 'Subtítulos desactivados',
    pressSpace: 'o presiona {key} para hablar',
    stopAudio: 'Detener audio',
    writeTo: 'Escribe tu mensaje...',
    transcribing: 'Transcribiendo...',
    initializing: 'Inicializando...',
    generatingFeedback: 'Generando tu feedback...',
    pleaseWait: 'Un momento por favor...',
    challengeXofY: 'Desafío {x} de {y}',
    coachHint: 'Pista del coach',
    entry: 'Entrada',

    // Sidebar
    scenario: 'Escenario',
    progress: 'Rendimiento',
    route: 'Recorrido',
    coachHintLabel: 'Pista del coach',
    settings: 'Ajustes',
    caseDetail: 'Detalle del caso',
    sessionStages: 'Etapas de la sesión',
    noHints: 'Sin pistas',
    hintsInChallenge: '{n} pista{s} en este desafío',
    yourInterlocutor: 'Tu interlocutor',
    activeTime: 'Tiempo activo',
    turns: 'Turnos',
    exchanges: '{n} intercambios',
    hintsUsed: 'Pistas usadas',
    xOfY: '{x} de {y}',
    visitMoments: 'Momentos de la visita',
    inProgress: 'En curso',
    noMomentsYet: 'Aún no hay momentos registrados. Continúa la conversación.',
    activeNow: 'Activa ahora',
    seenAgo: 'Vista {time}',
    toDiscover: 'Por descubrir',
    noHintsYet: 'Aún no hay pistas disponibles. Continúa la conversación.',
    newThread: 'Nuevo',
    clean: 'Limpiar',
    changeScenario: 'Cambiar escenario',
    newHintAvailable: 'Nueva pista disponible',

    // Visit moments
    presentation: 'Presentación',
    presentationDesc: 'Llegada a las instalaciones y entrevista de inicio con el equipo de planta',
    siteVisit: 'Recorrido por las instalaciones',
    siteVisitDesc: 'Visita a las áreas clave e identificación de riesgos A&S',
    closing: 'Cierre',
    closingDesc: 'Próximos pasos, Plan de Acción A&S y cierre de la visita',

    // Stances
    supportive: 'Colaborativo',
    neutral: 'Neutral',
    resistant: 'Resistente',
    challenging: 'Desafiante',
    open: 'Abierto',
    closed: 'Cerrado',
    skeptical: 'Escéptico',
    conciliatory: 'Conciliador',
    firm: 'Firme',

    // Chat
    conversation: 'Conversación',
    turnCount: '{n} turnos',

    // Feedback
    simulationResult: 'Resultado de simulación',
    newSimulation: 'Nueva simulación',
    readyAgain: '¿Listo para practicar de nuevo?',

    // Help modal
    howItWorks: 'Cómo funciona la simulación',
    helpIntro: 'Puedes interactuar por {voice} o por {text}.',
    helpSoftSkillsNote: 'Lo que se evalúa son tus habilidades blandas — cómo te comunicas, lideras y gestionas la conversación — no el conocimiento técnico.',
    voice: 'voz',
    text: 'texto',
    phase1: '1. Preséntate y explica tu motivación',
    phase1Desc: 'Inicia la conversación presentándote, explicando tu rol y la razón de la visita al representante del proyecto.',
    phase2: '2. Dos retos de habilidad',
    phase2Desc: 'El representante te planteará dos situaciones para poner a prueba la habilidad blanda que seleccionaste. Responde con empatía y profesionalismo.',
    phase3: '3. Feedback detallado',
    phase3Desc: 'Al finalizar recibirás una evaluación con tus fortalezas, oportunidades de mejora y una puntuación por criterio.',
    negotiationPhase: 'Fase',
    legendTitle: 'Leyenda de colores',
    legendHint: 'Pista del coach',
    legendGoodMove: 'Buen movimiento',
    legendWatchOut: 'Riesgo / advertencia',
    legendMoveAvailable: 'Sugerencia disponible',
    restartTutorial: 'Reiniciar tutorial',

    // Misc
    now: 'Ahora',
    ago: 'Hace {n} min',
    spaceKey: 'Espacio',
    occupationalHealth: 'Salud ocupacional',
    yourFeedback: 'Tu feedback',
    listen: 'Escuchar',
    seeMore: 'Ver más ↓',
    seeLess: 'Ver menos ↑',

    // Tutorial
    tutWelcomeTitle: '¡Bienvenido a la simulación!',
    tutWelcomeContent: 'Este breve recorrido te explica las funcionalidades principales de la vista de chat. Puedes saltar el tutorial en cualquier momento.',
    tutAvatarTitle: 'Representante del proyecto',
    tutAvatarContent: 'Aquí verás el avatar del representante con quien interactúas. Los anillos animados indican cuando él está hablando o cuando tú estás grabando.',
    tutContextTitle: 'Contexto del representante',
    tutMicTitle: 'Micrófono',
    tutMicContent: 'Toca este botón para hablar con el representante. Mientras grabas el botón se pone rojo; tócalo de nuevo para detener la grabación y enviar tu mensaje.',
    tutStopTitle: 'Detener audio',
    tutStopContent: 'Cuando el representante esté hablando aparece este botón. Úsalo para interrumpir el audio en cualquier momento.',
    tutTextTitle: 'Entrada de texto',
    tutTextContent: 'Si prefieres escribir, usa este campo de texto. Pulsa Enter o el botón de envío para mandar tu mensaje.',
    tutChatTitle: 'Ver / Ocultar conversación',
    tutChatContent: 'Este botón despliega el historial completo de la conversación. Puedes abrirlo y cerrarlo cuando quieras revisar lo que se ha dicho.',
    tutScenarioTitle: 'Escenario activo',
    tutScenarioContent: 'Aquí se muestra el escenario que seleccionaste: el tipo de proyecto, el nombre y una descripción breve del contexto en el que se desarrolla la simulación.',
    tutTimelineTitle: 'Recorrido de la visita',
    tutProgressTitle: 'Indicador de rendimiento',
    tutProgressContent: 'Esta barra refleja tu rendimiento general en la simulación. Aumenta a medida que demuestras las competencias evaluadas.',
    tutTurnsTitle: 'Turnos del desafío',
    tutTurnsContent: 'Cada segmento representa un turno de conversación que ya transcurrió. Es solo un indicador del avance en número de intercambios, no de tu desempeño.',
    tutHintsTitle: 'Pistas',
    tutHintsContent: 'Si te sientes bloqueado, expande esta sección para recibir una orientación contextual generada por el sistema. La pista se actualiza según el desafío activo.',
    tutSkillsTitle: 'Habilidades',
    tutSkillsContent: 'Aquí puedes seguir el estado de cada habilidad seleccionada: las marcadas en verde ya fueron evaluadas y las grises están pendientes.',
    tutHelpTitle: '¿Necesitas ayuda?',
    tutHelpContent: 'Este ícono abre el panel de ayuda. Desde allí también puedes volver a iniciar este tutorial cuando lo necesites. ¡Eso es todo, buena suerte en tu simulación!',
    jrBack: 'Atrás',
    jrClose: 'Cerrar',
    jrLast: 'Terminar',
    jrNext: 'Siguiente',
    jrNextLabeled: 'Siguiente ({current}/{total})',
    jrOpen: 'Abrir',
    jrSkip: 'Saltar tutorial',

    // Scenario selector extras
    scenarioAndLevel: 'Elige escenario y nivel',
    scenarioAndLevelDesc: 'Selecciona el sector del proyecto y la complejidad del caso que quieres practicar.',
    available: 'disponibles',
    selectedCase: 'Caso seleccionado',
    context: 'Contexto',
    yourInterlocutorLabel: 'Tu interlocutor',
    projectRepresentative: 'Representante del proyecto',
    challengesLabel: 'Desafíos',
    mode: 'Modo',
    voiceAndText: 'Voz y texto',
    backToOptions: 'Volver a opciones',
    selectOne: 'Selecciona uno',
    clickForDetail: 'Click para ver detalle completo',
    canChangeSkill: 'Puedes cambiar de habilidad luego de revisar el caso completo.',
    selectYourSkill: 'Selecciona tu habilidad',
    selectYourSkillDesc: 'Cada simulación enfoca en una soft skill clave. Elige la que quieres fortalecer.',
    skill: 'Habilidad',
    simulation: 'Simulación',
    nAvailable: '{n} disponibles',
    tutContextContent1: 'Debajo del nombre aparecen dos etiquetas: su actitud actual (colaborativo, neutral, resistente…) y la etapa del recorrido en la que te encuentras (recepción, recorrido, oficina…).',
    tutContextContent2: 'Justo debajo aparece el lenguaje corporal del representante, que te da contexto sobre su actitud no verbal.',
    tutContextContent3: 'Y cuando la escena cambia verás un cartel narrativo en ámbar describiendo ese momento (por ejemplo, al pasar de la bienvenida al recorrido por las instalaciones).',
    tutTimelineContent1: 'Esta sección marca los hitos escénicos de la visita (saludo, recorrido por instalaciones, oficina, despedida…).',
    tutTimelineContent2: 'El punto en verde indica el momento actual y los anteriores muestran un check cuando ya transcurrieron. Te sirve como mapa del avance narrativo de la conversación.',
  },

  en: {
    // Arcade lite
    insertCoin: 'AI Soft Skills Simulation | Negotiation Arena',
    pressStart: 'PRESS START',
    chooseSituation: 'Choose your counterpart',
    chooseSituationDesc: 'Two real negotiation situations — pick your counterpart and start the session.',
    selectSituationToStart: 'Select a situation to begin',
    readyToStart: 'Ready to start',
    gameOver: 'GAME OVER',
    stageClear: 'STAGE CLEAR',
    temperature: 'TEMP',
    simulationAI: 'SimulationAI',
    idbAse: 'Field Skills',
    live: 'Live',
    restart: 'Restart',
    contentManager: 'Content manager',

    loadingConfig: 'Loading configuration...',
    restoringConversation: 'Restoring conversation...',

    safeguards: 'Environmental and social safeguards',
    introTitle1: 'Train your skills during',
    introTitle2: 'a field visit',
    introSubtitle: 'This simulator trains your soft skills — communication, leadership, negotiation and more — in real conversations during a field visit. Your technical knowledge is not evaluated; what matters is how you communicate and manage the interaction.',
    startPractice: 'Start practice',
    introCtaBarHint: 'To continue, tap the green button. You will then choose scenario, level, and skill.',
    sessionTime: 'Approximately 10–15 minutes per session · Voice and text',
    introStep1Title: 'Scenario',
    introStep1Desc: 'Choose the sector and level of the project to supervise.',
    introStep2Title: 'Level',
    introStep2Desc: 'Set the challenge complexity.',
    introStep3Title: 'Skill',
    introStep3Desc: 'Select which soft skill you want to practice.',
    introStep4Title: 'Simulation',
    introStep4Desc: 'Converse by voice or text with your interlocutor.',

    stepXofY: 'Step {x} of {y}',
    back: 'Back',
    continue: 'Continue',
    selectScenario: 'Select a scenario to continue',
    selectLevel: 'Select a difficulty level',
    chooseScenario: 'Choose a scenario',
    chooseScenarioDesc: 'Select the type of project where you\'ll conduct your field visit.',
    difficultyLevel: 'Difficulty level',
    basic: 'Basic',
    intermediate: 'Intermediate',
    advanced: 'Advanced',
    basicDesc: 'Guided conversation with a cooperative representative. Key questions appear as suggestions.',
    intermediateDesc: 'The representative shows partial resistance and evasive answers. No automatic suggestions.',
    advancedDesc: 'Multiple interlocutors, contradictory information and time pressure. Decisions with consequences.',
    challenges: '{n} challenges',

    chooseSkill: 'Choose your skill',
    chooseSkillDesc: 'Select the competency you want to practice in this simulation.',
    selectedSkill: 'Selected skill',
    startSimulation: 'Start simulation',
    selectSkillToContinue: 'Select a skill to continue',
    definition: 'Definition',
    appliedToSARAS: 'Applied to SARAS',
    expectedExamples: 'Expected examples',

    handsFree: 'Hands-free',
    handsFreeOn: 'Hands-free ON',
    handsFreeOff: 'Hands-free OFF',
    recording: 'Recording',
    sessionCompleted: 'Session completed',
    yourScore: 'Your score',
    pts: 'pts',
    showMore: 'See more',
    showLess: 'Hide details',
    evaluatedOn: 'Evaluated on',
    yourScenario: 'Your scenario',
    visitContext: 'Visit context',
    howToStart: 'Your mission',
    howToStartDesc: 'Steer the conversation toward the agreement you need. Hold your ground, listen to the other side and negotiate with arguments. Press START to begin.',
    understood: 'Got it',
    start: 'Start',
    loadingAvatar: 'Loading avatar...',
    speaking: 'Speaking',
    listening: 'Listening',
    thinking: 'Thinking',
    thinkingDots: 'Thinking...',
    preparingAudio: 'Preparing audio...',
    listeningDots: 'Listening...',
    representativeSpeaking: 'The representative is speaking...',
    speakWhenReady: 'Speak when ready',
    userLabel: 'USER',
    subtitlesOn: 'Subtitles on',
    subtitlesOff: 'Subtitles off',
    pressSpace: 'or press {key} to speak',
    stopAudio: 'Stop audio',
    writeTo: 'Write your message...',
    transcribing: 'Transcribing...',
    initializing: 'Initializing...',
    generatingFeedback: 'Generating your feedback...',
    pleaseWait: 'Just a moment please...',
    challengeXofY: 'Challenge {x} of {y}',
    coachHint: 'Coach hint',
    entry: 'Entrance',

    scenario: 'Scenario',
    progress: 'Performance',
    route: 'Route',
    coachHintLabel: 'Coach hint',
    settings: 'Settings',
    caseDetail: 'Case details',
    sessionStages: 'Session stages',
    noHints: 'No hints',
    hintsInChallenge: '{n} hint{s} in this challenge',
    yourInterlocutor: 'Your interlocutor',
    activeTime: 'Active time',
    turns: 'Turns',
    exchanges: '{n} exchanges',
    hintsUsed: 'Hints used',
    xOfY: '{x} of {y}',
    visitMoments: 'Visit moments',
    inProgress: 'In progress',
    noMomentsYet: 'No moments recorded yet. Continue the conversation.',
    activeNow: 'Active now',
    seenAgo: 'Seen {time}',
    toDiscover: 'To discover',
    noHintsYet: 'No hints available yet. Continue the conversation.',
    newThread: 'New',
    clean: 'Clear',
    changeScenario: 'Change scenario',
    newHintAvailable: 'New hint available',

    presentation: 'Presentation',
    presentationDesc: 'Arrival at the facilities and initial meeting with the plant team',
    siteVisit: 'Site visit',
    siteVisitDesc: 'Visit to key areas and E&S risk identification',
    closing: 'Closing',
    closingDesc: 'Next steps, E&S Action Plan and visit closure',

    supportive: 'Supportive',
    neutral: 'Neutral',
    resistant: 'Resistant',
    challenging: 'Challenging',
    open: 'Open',
    closed: 'Closed',
    skeptical: 'Skeptical',
    conciliatory: 'Conciliatory',
    firm: 'Firm',

    conversation: 'Conversation',
    turnCount: '{n} turns',

    simulationResult: 'Simulation result',
    newSimulation: 'New simulation',
    readyAgain: 'Ready to practice again?',

    howItWorks: 'How the simulation works',
    helpIntro: 'You can interact by {voice} or {text}.',
    helpSoftSkillsNote: 'What is evaluated are your soft skills — how you communicate, lead and manage the conversation — not technical knowledge.',
    voice: 'voice',
    text: 'text',
    phase1: '1. Introduce yourself and explain your motivation',
    phase1Desc: 'Start the conversation by introducing yourself, explaining your role and the reason for the visit to the project representative.',
    phase2: '2. Two skill challenges',
    phase2Desc: 'The representative will present two situations to test the soft skill you selected. Respond with empathy and professionalism.',
    phase3: '3. Detailed feedback',
    phase3Desc: 'At the end you\'ll receive an evaluation with your strengths, areas for improvement and a score per criterion.',
    negotiationPhase: 'Phase',
    legendTitle: 'Color legend',
    legendHint: 'Coach hint',
    legendGoodMove: 'Good move',
    legendWatchOut: 'Risk / warning',
    legendMoveAvailable: 'Suggested move',
    restartTutorial: 'Restart tutorial',

    now: 'Now',
    ago: '{n} min ago',
    spaceKey: 'Space',
    occupationalHealth: 'Occupational health',
    yourFeedback: 'Your feedback',
    listen: 'Listen',
    seeMore: 'See more ↓',
    seeLess: 'See less ↑',

    tutWelcomeTitle: 'Welcome to the simulation!',
    tutWelcomeContent: 'This brief tour explains the main features of the chat view. You can skip the tutorial at any time.',
    tutAvatarTitle: 'Project representative',
    tutAvatarContent: 'Here you\'ll see the avatar of the representative you\'re interacting with. The animated rings indicate when they\'re speaking or when you\'re recording.',
    tutContextTitle: 'Representative context',
    tutMicTitle: 'Microphone',
    tutMicContent: 'Tap this button to speak with the representative. While recording, the button turns red; tap again to stop recording and send your message.',
    tutStopTitle: 'Stop audio',
    tutStopContent: 'When the representative is speaking, this button appears. Use it to interrupt the audio at any time.',
    tutTextTitle: 'Text input',
    tutTextContent: 'If you prefer typing, use this text field. Press Enter or the send button to submit your message.',
    tutChatTitle: 'Show / Hide conversation',
    tutChatContent: 'This button expands the full conversation history. Open or close it whenever you want to review what\'s been said.',
    tutScenarioTitle: 'Active scenario',
    tutScenarioContent: 'Here you can see the scenario you selected: the project type, name, and a brief description of the simulation context.',
    tutTimelineTitle: 'Visit route',
    tutProgressTitle: 'Performance indicator',
    tutProgressContent: 'This bar reflects your overall performance in the simulation. It increases as you demonstrate the evaluated competencies.',
    tutTurnsTitle: 'Challenge turns',
    tutTurnsContent: 'Each segment represents a conversation turn that has already occurred. It\'s just an indicator of the number of exchanges, not your performance.',
    tutHintsTitle: 'Hints',
    tutHintsContent: 'If you feel stuck, expand this section to receive contextual guidance generated by the system. The hint updates based on the active challenge.',
    tutSkillsTitle: 'Skills',
    tutSkillsContent: 'Here you can track the status of each selected skill: those marked in green have already been evaluated and the grey ones are pending.',
    tutHelpTitle: 'Need help?',
    tutHelpContent: 'This icon opens the help panel. From there you can also restart this tutorial whenever you need. That\'s all, good luck with your simulation!',
    jrBack: 'Back',
    jrClose: 'Close',
    jrLast: 'Finish',
    jrNext: 'Next',
    jrNextLabeled: 'Next ({current}/{total})',
    jrOpen: 'Open',
    jrSkip: 'Skip tutorial',

    scenarioAndLevel: 'Choose scenario and level',
    scenarioAndLevelDesc: 'Select the project sector and the complexity of the case you want to practice.',
    available: 'available',
    selectedCase: 'Selected case',
    context: 'Context',
    yourInterlocutorLabel: 'Your interlocutor',
    projectRepresentative: 'Project representative',
    challengesLabel: 'Challenges',
    mode: 'Mode',
    voiceAndText: 'Voice and text',
    backToOptions: 'Back to options',
    selectOne: 'Select one',
    clickForDetail: 'Click to see full details',
    canChangeSkill: 'You can change the skill after reviewing the full case.',
    selectYourSkill: 'Select your skill',
    selectYourSkillDesc: 'Each simulation focuses on a key soft skill. Choose the one you want to strengthen.',
    skill: 'Skill',
    simulation: 'Simulation',
    nAvailable: '{n} available',
    tutContextContent1: 'Below the name you\'ll see two labels: their current attitude (supportive, neutral, resistant…) and the stage of the visit you\'re in (reception, tour, office…).',
    tutContextContent2: 'Just below, you\'ll see the representative\'s body language, giving you context about their non-verbal attitude.',
    tutContextContent3: 'And when the scene changes, you\'ll see an amber narrative sign describing that moment (for example, when transitioning from the welcome to the site tour).',
    tutTimelineContent1: 'This section marks the scenic milestones of the visit (greeting, facility tour, office, farewell…).',
    tutTimelineContent2: 'The green dot indicates the current moment and previous ones show a checkmark when they\'ve passed. It serves as a map of the narrative progress of the conversation.',
  },
};

const I18nContext = createContext({ t: (k) => k, lang: 'es' });

export function I18nProvider({ lang = 'es', children }) {
    const dict = translations[lang] || translations.es;
    const t = (key, params) => {
        let str = dict[key] ?? translations.es[key] ?? key;
        if (params) {
            Object.entries(params).forEach(([k, v]) => {
                str = str.replace(new RegExp(`\\{${k}\\}`, 'g'), v);
            });
        }
        return str;
    };
    return <I18nContext.Provider value={{ t, lang }}>{children}</I18nContext.Provider>;
}

export function useI18n() {
    return useContext(I18nContext);
}
